/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipBulkDeleteRequestSchema = z.object({
  membershipIds: z.array(z.int()).min(1),
});
